import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loading } from '../components/Loading'
import { authService } from '../auth/AuthService'

export function SignoutCallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Process the signout callback
    authService
      .getUserManager()
      .signoutRedirectCallback()
      .then(() => {
        // Clear any remaining session storage
        sessionStorage.clear()
        // Navigate to home page
        navigate('/', { replace: true })
      })
      .catch((error) => {
        console.error('Signout callback error:', error)
        // Even if there's an error, clear storage and go home
        sessionStorage.clear()
        navigate('/', { replace: true })
      })
  }, [navigate])

  return <Loading />
}
